import { MeshReflectorMaterial } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";

export default function Floor() {
  const texture = useLoader(TextureLoader, "./img/wood.webp");

  return (
    <mesh rotation-x={-Math.PI / 2} castShadow receiveShadow>
      <circleGeometry attach="geometry" args={[100]} />
      <meshPhysicalMaterial
        attach="material"
        map={texture}
        metalness={0.8}
        roughness={0.2}
      />
      {/* <meshStandardMaterial
      attach="material"
      map={texture}
      metalness={0.8}
      roughness={0.2} 
    /> */}
    </mesh>
  );
}
